/**
 * Fire-and-forget a promise without using the `void` operator (eslint `no-void`).
 * Caller should handle errors inside the async work (try/catch) when failures
 * must not become unhandled rejections.
 */
export function fork(_) {
    return undefined;
}
//# sourceMappingURL=fork.js.map